// import { useEffect, useState, useMemo, useCallback } from "react";
// import { doc, getDoc, setDoc } from "firebase/firestore";
// import { db } from "../../firebase";
// import s from "./UserCabinetEditor.module.css";
// import ReactQuill from "react-quill";
// import "react-quill/dist/quill.snow.css";

// export default function UserCabinetEditor() {
//   const refUser = doc(db, "siteContent", "userCabinet");
//   const refBusiness = doc(db, "siteContent", "blockBusiness");
//   const refMaister = doc(db, "siteContent", "blockMaister");
//   const refReader = doc(db, "siteContent", "blockReader");

//   const [userModel, setUserModel] = useState(null);
//   const [businessModel, setBusinessModel] = useState(null);
//   const [maisterModel, setMaisterModel] = useState(null);
//   const [readerModel, setReaderModel] = useState(null);
//   const [saving, setSaving] = useState(false);
//   const [error, setError] = useState("");

//   useEffect(() => {
//     (async () => {
//       try {
//         const [u, b, m, r] = await Promise.all([
//           getDoc(refUser),
//           getDoc(refBusiness),
//           getDoc(refMaister),
//           getDoc(refReader),
//         ]);

//         // Ніяких дефолтів — тільки дані з БД або порожній об'єкт
//         setUserModel(u.exists() ? u.data() : {});
//         setBusinessModel(b.exists() ? b.data() : {});
//         setMaisterModel(m.exists() ? m.data() : {});
//         setReaderModel(r.exists() ? r.data() : {});
//       } catch (e) {
//         console.error(e);
//         setError(
//           "Помилка завантаження даних. Перевірте підключення до Firestore."
//         );
//         setUserModel({});
//         setBusinessModel({});
//         setMaisterModel({});
//         setReaderModel({});
//       }
//     })();
//   }, []);

//   const save = async () => {
//     setSaving(true);
//     setError("");
//     try {
//       await Promise.all([
//         setDoc(refUser, userModel || {}, { merge: true }),
//         setDoc(refBusiness, businessModel || {}, { merge: true }),
//         setDoc(refMaister, maisterModel || {}, { merge: true }),
//         setDoc(refReader, readerModel || {}, { merge: true }),
//       ]);
//       alert("Збережено!");
//     } catch (e) {
//       console.error(e);
//       setError("Не вдалося зберегти зміни. Спробуйте ще раз.");
//     } finally {
//       setSaving(false);
//     }
//   };

//   if (
//     userModel === null ||
//     businessModel === null ||
//     maisterModel === null ||
//     readerModel === null
//   ) {
//     return (
//       <div className={s.loadingWrap}>
//         <div className={s.loader} />
//         <div className={s.loadingText}>Завантаження редактора…</div>
//       </div>
//     );
//   }

//   return (
//     <div className={s.editor}>
//       {/* Sticky header */}
//       <header className={s.header}>
//         <div className={s.headerLeft}>
//           <div className={s.logoDot} />
//           <h1 className={s.title}>Кабінет користувача — адмінка</h1>
//         </div>
//         <div className={s.headerRight}>
//           <a className={s.headerLink} href="#user">
//             UserCabinet
//           </a>
//           <a className={s.headerLink} href="#business">
//             Business
//           </a>
//           <a className={s.headerLink} href="#maister">
//             Maister
//           </a>
//           <a className={s.headerLink} href="#reader">
//             Reader
//           </a>
//           <button
//             className={`${s.btn} ${s.btnPrimary}`}
//             onClick={save}
//             disabled={saving}
//           >
//             {saving ? "Збереження…" : "Зберегти"}
//           </button>
//         </div>
//       </header>

//       {error && <div className={s.error}>{error}</div>}

//       <main className={s.main}>
//         {/* ================= USER CABINET ================ */}
//         <Section id="user" title="UserCabinet">
//           <SubTitle>Hero</SubTitle>
//           <Textarea
//             label="Місія"
//             rows={2}
//             value={userModel?.hero?.missionText || ""}
//             onChange={(v) =>
//               setUserModel({
//                 ...userModel,
//                 hero: { ...(userModel?.hero || {}), missionText: v },
//               })
//             }
//           />
//           <Textarea
//             label="Мета"
//             rows={2}
//             value={userModel?.hero?.goalText || ""}
//             onChange={(v) =>
//               setUserModel({
//                 ...userModel,
//                 hero: { ...(userModel?.hero || {}), goalText: v },
//               })
//             }
//           />

//           <SubTitle>Соцпосилання</SubTitle>
//           <div className={s.grid2}>
//             {[
//               ["facebookUrl", "Facebook URL"],
//               ["email", "Email"],
//               ["telegramUrl", "Telegram URL"],
//               ["viberUrl", "Viber URL"],
//             ].map(([k, label]) => (
//               <Input
//                 key={k}
//                 label={label}
//                 value={userModel?.socialLinks?.[k] || ""}
//                 onChange={(v) =>
//                   setUserModel({
//                     ...userModel,
//                     socialLinks: { ...(userModel?.socialLinks || {}), [k]: v },
//                   })
//                 }
//               />
//             ))}
//           </div>
//           <SubTitle>Опис за ролями (HTML)</SubTitle>
//           <div className={s.grid2}>
//             <HtmlEditor
//               label='Член "Клубу Майстрів"'
//               value={userModel?.registration?.byRole?.club || ""}
//               onChange={(v) =>
//                 setUserModel({
//                   ...userModel,
//                   registration: {
//                     ...(userModel?.registration || {}),
//                     byRole: {
//                       ...(userModel?.registration?.byRole || {}),
//                       club: v,
//                     },
//                   },
//                 })
//               }
//             />
//             <HtmlEditor
//               label="Бібліотекар"
//               value={userModel?.registration?.byRole?.librarian || ""}
//               onChange={(v) =>
//                 setUserModel({
//                   ...userModel,
//                   registration: {
//                     ...(userModel?.registration || {}),
//                     byRole: {
//                       ...(userModel?.registration?.byRole || {}),
//                       librarian: v,
//                     },
//                   },
//                 })
//               }
//             />
//           </div>
//           <div className={s.grid2}>
//             <HtmlEditor
//               label="Продавець книг в книгарні"
//               value={userModel?.registration?.byRole?.retailer || ""}
//               onChange={(v) =>
//                 setUserModel({
//                   ...userModel,
//                   registration: {
//                     ...(userModel?.registration || {}),
//                     byRole: {
//                       ...(userModel?.registration?.byRole || {}),
//                       retailer: v,
//                     },
//                   },
//                 })
//               }
//             />
//             <HtmlEditor
//               label="Бізнес-партнер"
//               value={userModel?.registration?.byRole?.business || ""}
//               onChange={(v) =>
//                 setUserModel({
//                   ...userModel,
//                   registration: {
//                     ...(userModel?.registration || {}),
//                     byRole: {
//                       ...(userModel?.registration?.byRole || {}),
//                       business: v,
//                     },
//                   },
//                 })
//               }
//             />
//           </div>

//           <SubTitle>Реєстрація / опис</SubTitle>
//           <Input
//             label="Префікс заголовка"
//             value={userModel?.registration?.prefix || ""}
//             onChange={(v) =>
//               setUserModel({
//                 ...userModel,
//                 registration: { ...(userModel?.registration || {}), prefix: v },
//               })
//             }
//           />
//           <HtmlEditor
//             label="Опис (HTML)"
//             value={userModel?.registration?.descriptionHtml || ""}
//             onChange={(v) =>
//               setUserModel({
//                 ...userModel,
//                 registration: {
//                   ...(userModel?.registration || {}),
//                   descriptionHtml: v,
//                 },
//               })
//             }
//           />

//           <SubTitle>Таби</SubTitle>
//           <div className={s.cardSoft}>
//             {(userModel?.blocks || []).map((b, idx) => (
//               <div key={b.id ?? idx} className={s.row}>
//                 <input
//                   type="number"
//                   className={s.inputNarrow}
//                   value={b.id ?? ""}
//                   onChange={(e) => {
//                     const v = Number(e.target.value);
//                     const blocks = [...(userModel?.blocks || [])];
//                     blocks[idx] = { ...blocks[idx], id: v };
//                     setUserModel({ ...userModel, blocks });
//                   }}
//                 />
//                 <input
//                   className={s.input}
//                   value={b.title ?? ""}
//                   onChange={(e) => {
//                     const blocks = [...(userModel?.blocks || [])];
//                     blocks[idx] = { ...blocks[idx], title: e.target.value };
//                     setUserModel({ ...userModel, blocks });
//                   }}
//                 />
//                 <button
//                   className={`${s.btn} ${s.btnGhost}`}
//                   onClick={() => {
//                     const blocks = (userModel?.blocks || []).filter(
//                       (_, i) => i !== idx
//                     );
//                     setUserModel({ ...userModel, blocks });
//                   }}
//                   type="button"
//                 >
//                   Видалити
//                 </button>
//               </div>
//             ))}
//             <button
//               className={`${s.btn} ${s.btnSoft}`}
//               onClick={() =>
//                 setUserModel({
//                   ...userModel,
//                   blocks: [
//                     ...(userModel?.blocks || []),
//                     { id: Date.now(), title: "Новий таб" },
//                   ],
//                 })
//               }
//               type="button"
//             >
//               Додати таб
//             </button>
//           </div>

//           <SubTitle>Знижка (не підписані)</SubTitle>
//           <div className={s.grid2}>
//             {[
//               ["title", "Заголовок"],
//               ["subtitle", "Підзаголовок"],
//               ["stepsTitle", "Заголовок для кроків"],
//               ["getIdBotUrl", "Посилання на GetID бот"],
//               ["channelUrl", "Посилання на Telegram-канал"],
//             ].map(([k, label]) => (
//               <Input
//                 key={k}
//                 label={label}
//                 value={userModel?.discount?.unsigned?.[k] || ""}
//                 onChange={(v) =>
//                   setUserModel({
//                     ...userModel,
//                     discount: {
//                       ...(userModel?.discount || {}),
//                       unsigned: {
//                         ...(userModel?.discount?.unsigned || {}),
//                         [k]: v,
//                       },
//                     },
//                   })
//                 }
//               />
//             ))}
//           </div>

//           <div className={s.cardSoft}>
//             <div className={s.labelOnly}>Кроки</div>
//             {(userModel?.discount?.unsigned?.steps || []).map((sVal, i) => (
//               <div key={i} className={s.row}>
//                 <textarea
//                   className={s.textarea}
//                   rows={2}
//                   value={sVal}
//                   onChange={(e) => {
//                     const steps = [
//                       ...(userModel?.discount?.unsigned?.steps || []),
//                     ];
//                     steps[i] = e.target.value;
//                     setUserModel({
//                       ...userModel,
//                       discount: {
//                         ...(userModel?.discount || {}),
//                         unsigned: {
//                           ...(userModel?.discount?.unsigned || {}),
//                           steps,
//                         },
//                       },
//                     });
//                   }}
//                 />
//                 <button
//                   className={`${s.btn} ${s.btnGhost}`}
//                   onClick={() => {
//                     const steps = (
//                       userModel?.discount?.unsigned?.steps || []
//                     ).filter((_, idx) => idx !== i);
//                     setUserModel({
//                       ...userModel,
//                       discount: {
//                         ...(userModel?.discount || {}),
//                         unsigned: {
//                           ...(userModel?.discount?.unsigned || {}),
//                           steps,
//                         },
//                       },
//                     });
//                   }}
//                   type="button"
//                 >
//                   −
//                 </button>
//               </div>
//             ))}
//             <button
//               className={`${s.btn} ${s.btnSoft}`}
//               onClick={() =>
//                 setUserModel({
//                   ...userModel,
//                   discount: {
//                     ...(userModel?.discount || {}),
//                     unsigned: {
//                       ...(userModel?.discount?.unsigned || {}),
//                       steps: [
//                         ...(userModel?.discount?.unsigned?.steps || []),
//                         "Новий крок",
//                       ],
//                     },
//                   },
//                 })
//               }
//               type="button"
//             >
//               Додати крок
//             </button>
//           </div>

//           <SubTitle>Знижка (підписані)</SubTitle>
//           <div className={s.grid3}>
//             {[
//               ["noteTitle", "Заголовок"],
//               ["note", "Примітка"],
//               ["inviteCta", "Кнопка запрошення"],
//             ].map(([k, label]) => (
//               <Input
//                 key={k}
//                 label={label}
//                 value={userModel?.discount?.signed?.[k] || ""}
//                 onChange={(v) =>
//                   setUserModel({
//                     ...userModel,
//                     discount: {
//                       ...(userModel?.discount || {}),
//                       signed: {
//                         ...(userModel?.discount?.signed || {}),
//                         [k]: v,
//                       },
//                     },
//                   })
//                 }
//               />
//             ))}
//           </div>

//           <SubTitle>Слони</SubTitle>
//           <HtmlEditor
//             label='Текст перед курсом (HTML) — наприклад: "Ви можете <br /> сплачувати слонами..."'
//             value={userModel?.elephants?.leadHtml || ""}
//             onChange={(v) =>
//               setUserModel({
//                 ...userModel,
//                 elephants: { ...(userModel?.elephants || {}), leadHtml: v },
//               })
//             }
//           />
//           <div className={s.grid2}>
//             <Input
//               label="Інфо для клубу"
//               value={userModel?.elephants?.infoClub || ""}
//               onChange={(v) =>
//                 setUserModel({
//                   ...userModel,
//                   elephants: { ...(userModel?.elephants || {}), infoClub: v },
//                 })
//               }
//             />
//             <Input
//               label="Інфо для читача"
//               value={userModel?.elephants?.infoReader || ""}
//               onChange={(v) =>
//                 setUserModel({
//                   ...userModel,
//                   elephants: { ...(userModel?.elephants || {}), infoReader: v },
//                 })
//               }
//             />
//           </div>
//         </Section>

//         {/* ================= BLOCK BUSINESS ================ */}
//         <Section id="business" title="BlockBusiness (Бізнес-партнер)">
//           <div className={s.grid2}>
//             <Input
//               label="Анкета партнера — назва"
//               value={businessModel?.partnerForm?.label || ""}
//               onChange={(v) =>
//                 setBusinessModel({
//                   ...businessModel,
//                   partnerForm: {
//                     ...(businessModel?.partnerForm || {}),
//                     label: v,
//                   },
//                 })
//               }
//             />
//             <Input
//               label="Анкета партнера — URL"
//               value={businessModel?.partnerForm?.url || ""}
//               onChange={(v) =>
//                 setBusinessModel({
//                   ...businessModel,
//                   partnerForm: {
//                     ...(businessModel?.partnerForm || {}),
//                     url: v,
//                   },
//                 })
//               }
//             />
//           </div>

//           <HtmlEditor
//             label="Intro (HTML) Бізнес"
//             value={businessModel?.partnerIntroHtml || ""}
//             onChange={(v) =>
//               setBusinessModel({ ...businessModel, partnerIntroHtml: v })
//             }
//           />

//           <Input
//             label="H1 — Контакти персонального менеджера"
//             value={businessModel?.personalManagerContact || ""}
//             onChange={(v) =>
//               setBusinessModel({ ...businessModel, personalManagerContact: v })
//             }
//           />
//           <Textarea
//             label="Опис менеджера (текст)"
//             value={businessModel?.personalManager || ""}
//             onChange={(v) =>
//               setBusinessModel({ ...businessModel, personalManager: v })
//             }
//           />

//           <div className={s.grid2}>
//             <Input
//               label="Route «Прайс-гурт»"
//               value={businessModel?.priceRoute || ""}
//               onChange={(v) =>
//                 setBusinessModel({ ...businessModel, priceRoute: v })
//               }
//             />
//             <Input
//               label="Текст лінку «Прайс-гурт»"
//               value={businessModel?.priceLinkText || ""}
//               onChange={(v) =>
//                 setBusinessModel({ ...businessModel, priceLinkText: v })
//               }
//             />
//           </div>

//           <HtmlEditor
//             label="Абзац про «Прайс-гурт» (HTML)"
//             value={businessModel?.optIntroHtml || ""}
//             onChange={(v) =>
//               setBusinessModel({ ...businessModel, optIntroHtml: v })
//             }
//           />

//           <div className={s.grid2}>
//             <Input
//               label="Плейлист — назва"
//               value={businessModel?.salesPlaylist?.label || ""}
//               onChange={(v) =>
//                 setBusinessModel({
//                   ...businessModel,
//                   salesPlaylist: {
//                     ...(businessModel?.salesPlaylist || {}),
//                     label: v,
//                   },
//                 })
//               }
//             />
//             <Input
//               label="Плейлист — URL"
//               value={businessModel?.salesPlaylist?.url || ""}
//               onChange={(v) =>
//                 setBusinessModel({
//                   ...businessModel,
//                   salesPlaylist: {
//                     ...(businessModel?.salesPlaylist || {}),
//                     url: v,
//                   },
//                 })
//               }
//             />
//           </div>

//           <HtmlEditor
//             label="Примітка до плейлиста (HTML)"
//             value={businessModel?.salesPlaylistNoteHtml || ""}
//             onChange={(v) =>
//               setBusinessModel({ ...businessModel, salesPlaylistNoteHtml: v })
//             }
//           />

//           <div className={s.grid3}>
//             <Input
//               label="H1 — Знижки"
//               value={businessModel?.discountTitle || ""}
//               onChange={(v) =>
//                 setBusinessModel({ ...businessModel, discountTitle: v })
//               }
//             />
//             <Input
//               label="H1 — Комерційни новини"
//               value={businessModel?.newsTitle || ""}
//               onChange={(v) =>
//                 setBusinessModel({ ...businessModel, newsTitle: v })
//               }
//             />
//             <Input
//               label="H1 — Звернення видавництва"
//               value={businessModel?.turnToTitle || ""}
//               onChange={(v) =>
//                 setBusinessModel({ ...businessModel, turnToTitle: v })
//               }
//             />
//           </div>

//           <div className={s.grid3}>
//             <HtmlEditor
//               label="Текст «Знижки» (HTML)"
//               value={businessModel?.discountHtml || ""}
//               onChange={(v) =>
//                 setBusinessModel({ ...businessModel, discountHtml: v })
//               }
//             />
//             <HtmlEditor
//               label="Новини (HTML)"
//               value={businessModel?.newsHtml || ""}
//               onChange={(v) =>
//                 setBusinessModel({ ...businessModel, newsHtml: v })
//               }
//             />
//             <HtmlEditor
//               label="Звернення (HTML)"
//               value={businessModel?.turnToHtml || ""}
//               onChange={(v) =>
//                 setBusinessModel({ ...businessModel, turnToHtml: v })
//               }
//             />
//           </div>

//           <div className={s.grid2}>
//             <HtmlEditor
//               label="Питання (HTML)"
//               value={businessModel?.questionHtml || ""}
//               onChange={(v) =>
//                 setBusinessModel({ ...businessModel, questionHtml: v })
//               }
//             />
//             <HtmlEditor
//               label="Опис PDF (HTML)"
//               value={businessModel?.pdfToHtml || ""}
//               onChange={(v) =>
//                 setBusinessModel({ ...businessModel, pdfToHtml: v })
//               }
//             />
//           </div>
//         </Section>

//         {/* ================= BLOCK MAISTER ================ */}
//         <Section id="maister" title="BlockMaister (Майстер/Автор)">
//           <div className={s.grid2}>
//             <Input
//               label="Анкета автора — назва"
//               value={maisterModel?.authorForm?.label || ""}
//               onChange={(v) =>
//                 setMaisterModel({
//                   ...maisterModel,
//                   authorForm: { ...(maisterModel?.authorForm || {}), label: v },
//                 })
//               }
//             />
//             <Input
//               label="Анкета автора — URL"
//               value={maisterModel?.authorForm?.url || ""}
//               onChange={(v) =>
//                 setMaisterModel({
//                   ...maisterModel,
//                   authorForm: { ...(maisterModel?.authorForm || {}), url: v },
//                 })
//               }
//             />
//           </div>

//           <HtmlEditor
//             label="Оновіть дані (HTML)"
//             value={maisterModel?.updateDataHtml || ""}
//             onChange={(v) =>
//               setMaisterModel({ ...maisterModel, updateDataHtml: v })
//             }
//           />

//           <div className={s.grid2}>
//             <Input
//               label="Анкета майстра — назва"
//               value={maisterModel?.masterForm?.label || ""}
//               onChange={(v) =>
//                 setMaisterModel({
//                   ...maisterModel,
//                   masterForm: { ...(maisterModel?.masterForm || {}), label: v },
//                 })
//               }
//             />
//             <Input
//               label="Анкета майстра — URL"
//               value={maisterModel?.masterForm?.url || ""}
//               onChange={(v) =>
//                 setMaisterModel({
//                   ...maisterModel,
//                   masterForm: { ...(maisterModel?.masterForm || {}), url: v },
//                 })
//               }
//             />
//           </div>

//           <HtmlEditor
//             label="Пояснення (HTML)"
//             value={maisterModel?.anketMaisterHtml || ""}
//             onChange={(v) =>
//               setMaisterModel({ ...maisterModel, anketMaisterHtml: v })
//             }
//           />

//           <Input
//             label="Email редактора"
//             value={maisterModel?.editorEmail || ""}
//             onChange={(v) =>
//               setMaisterModel({ ...maisterModel, editorEmail: v })
//             }
//           />

//           <HtmlEditor
//             label="Персональний менеджер (HTML)"
//             value={maisterModel?.personalManagerHtml || ""}
//             onChange={(v) =>
//               setMaisterModel({ ...maisterModel, personalManagerHtml: v })
//             }
//           />

//           <div className={s.grid2}>
//             <Input
//               label="Подати рукопис — назва"
//               value={maisterModel?.submitManuscript?.label || ""}
//               onChange={(v) =>
//                 setMaisterModel({
//                   ...maisterModel,
//                   submitManuscript: {
//                     ...(maisterModel?.submitManuscript || {}),
//                     label: v,
//                   },
//                 })
//               }
//             />
//             <Input
//               label="Подати рукопис — email"
//               value={maisterModel?.submitManuscript?.mailto || ""}
//               onChange={(v) =>
//                 setMaisterModel({
//                   ...maisterModel,
//                   submitManuscript: {
//                     ...(maisterModel?.submitManuscript || {}),
//                     mailto: v,
//                   },
//                 })
//               }
//             />
//           </div>

//           <div className={s.grid2}>
//             <Input
//               label="Форма рукопису — назва"
//               value={maisterModel?.manuscriptForm?.label || ""}
//               onChange={(v) =>
//                 setMaisterModel({
//                   ...maisterModel,
//                   manuscriptForm: {
//                     ...(maisterModel?.manuscriptForm || {}),
//                     label: v,
//                   },
//                 })
//               }
//             />
//             <Input
//               label="Форма рукопису — URL"
//               value={maisterModel?.manuscriptForm?.url || ""}
//               onChange={(v) =>
//                 setMaisterModel({
//                   ...maisterModel,
//                   manuscriptForm: {
//                     ...(maisterModel?.manuscriptForm || {}),
//                     url: v,
//                   },
//                 })
//               }
//             />
//           </div>

//           <HtmlEditor
//             label="Розділ про рукопис (HTML)"
//             value={maisterModel?.manuscriptHtml || ""}
//             onChange={(v) =>
//               setMaisterModel({ ...maisterModel, manuscriptHtml: v })
//             }
//           />

//           <Input
//             label="H1 — Допомогти авторам"
//             value={maisterModel?.helpAutorTitle || ""}
//             onChange={(v) =>
//               setMaisterModel({ ...maisterModel, helpAutorTitle: v })
//             }
//           />
//           <HtmlEditor
//             label="Текст (HTML)"
//             value={maisterModel?.helpAutorHtml || ""}
//             onChange={(v) =>
//               setMaisterModel({ ...maisterModel, helpAutorHtml: v })
//             }
//           />

//           <div className={s.grid2}>
//             <Input
//               label="Опікунська рада — назва"
//               value={maisterModel?.opikunForm?.label || ""}
//               onChange={(v) =>
//                 setMaisterModel({
//                   ...maisterModel,
//                   opikunForm: { ...(maisterModel?.opikunForm || {}), label: v },
//                 })
//               }
//             />
//             <Input
//               label="Опікунська рада — URL"
//               value={maisterModel?.opikunForm?.url || ""}
//               onChange={(v) =>
//                 setMaisterModel({
//                   ...maisterModel,
//                   opikunForm: { ...(maisterModel?.opikunForm || {}), url: v },
//                 })
//               }
//             />
//           </div>

//           <HtmlEditor
//             label="Опікунська рада — опис (HTML)"
//             value={maisterModel?.opicunTextHtml || ""}
//             onChange={(v) =>
//               setMaisterModel({ ...maisterModel, opicunTextHtml: v })
//             }
//           />

//           <div className={s.grid2}>
//             <Input
//               label="Шукаємо автора — назва"
//               value={maisterModel?.searchAutor?.label || ""}
//               onChange={(v) =>
//                 setMaisterModel({
//                   ...maisterModel,
//                   searchAutor: {
//                     ...(maisterModel?.searchAutor || {}),
//                     label: v,
//                   },
//                 })
//               }
//             />
//             <Input
//               label="Шукаємо автора — URL"
//               value={maisterModel?.searchAutor?.url || ""}
//               onChange={(v) =>
//                 setMaisterModel({
//                   ...maisterModel,
//                   searchAutor: { ...(maisterModel?.searchAutor || {}), url: v },
//                 })
//               }
//             />
//           </div>

//           <HtmlEditor
//             label="Шукаємо автора — текст (HTML)"
//             value={maisterModel?.searchAutorTextHtml || ""}
//             onChange={(v) =>
//               setMaisterModel({ ...maisterModel, searchAutorTextHtml: v })
//             }
//           />

//           <div className={s.grid2}>
//             <Input
//               label="Telegram — назва"
//               value={maisterModel?.tgChannel?.label || ""}
//               onChange={(v) =>
//                 setMaisterModel({
//                   ...maisterModel,
//                   tgChannel: { ...(maisterModel?.tgChannel || {}), label: v },
//                 })
//               }
//             />
//             <Input
//               label="Telegram — URL"
//               value={maisterModel?.tgChannel?.url || ""}
//               onChange={(v) =>
//                 setMaisterModel({
//                   ...maisterModel,
//                   tgChannel: { ...(maisterModel?.tgChannel || {}), url: v },
//                 })
//               }
//             />
//           </div>

//           <HtmlEditor
//             label="Telegram — опис (HTML)"
//             value={maisterModel?.tgChanelTextHtml || ""}
//             onChange={(v) =>
//               setMaisterModel({ ...maisterModel, tgChanelTextHtml: v })
//             }
//           />
//         </Section>

//         {/* ================= BLOCK READER ================ */}
//         <Section id="reader" title="BlockReader (Читач / Клуб майстрів)">
//           <Input
//             label="Заголовок (Telegram)"
//             value={readerModel?.telegramTitle || ""}
//             onChange={(v) =>
//               setReaderModel({ ...readerModel, telegramTitle: v })
//             }
//           />
//           <HtmlEditor
//             label="Опис (HTML)"
//             value={readerModel?.descriptionHtml || ""}
//             onChange={(v) =>
//               setReaderModel({ ...readerModel, descriptionHtml: v })
//             }
//           />
//           <div className={s.grid2}>
//             <Input
//               label="Опікунська рада — назва"
//               value={readerModel?.guardianForm?.label || ""}
//               onChange={(v) =>
//                 setReaderModel({
//                   ...readerModel,
//                   guardianForm: {
//                     ...(readerModel?.guardianForm || {}),
//                     label: v,
//                   },
//                 })
//               }
//             />
//             <Input
//               label="Опікунська рада — URL"
//               value={readerModel?.guardianForm?.url || ""}
//               onChange={(v) =>
//                 setReaderModel({
//                   ...readerModel,
//                   guardianForm: {
//                     ...(readerModel?.guardianForm || {}),
//                     url: v,
//                   },
//                 })
//               }
//             />
//           </div>
//           <HtmlEditor
//             label="Опікунська рада — текст (HTML)"
//             value={readerModel?.guardianTextHtml || ""}
//             onChange={(v) =>
//               setReaderModel({ ...readerModel, guardianTextHtml: v })
//             }
//           />
//           <div className={s.grid2}>
//             <Input
//               label="Гурт-замовлення — назва"
//               value={readerModel?.groupOrder?.label || ""}
//               onChange={(v) =>
//                 setReaderModel({
//                   ...readerModel,
//                   groupOrder: { ...(readerModel?.groupOrder || {}), label: v },
//                 })
//               }
//             />
//             <Input
//               label="Гурт-замовлення — URL"
//               value={readerModel?.groupOrder?.url || ""}
//               onChange={(v) =>
//                 setReaderModel({
//                   ...readerModel,
//                   groupOrder: { ...(readerModel?.groupOrder || {}), url: v },
//                 })
//               }
//             />
//           </div>
//           <HtmlEditor
//             label="Гурт-замовлення — текст (HTML)"
//             value={readerModel?.groupOrderTextHtml || ""}
//             onChange={(v) =>
//               setReaderModel({ ...readerModel, groupOrderTextHtml: v })
//             }
//           />
//           <div className={s.grid2}>
//             <Input
//               label="CTA до Прайс-гурт — текст"
//               value={readerModel?.priceCta?.label || ""}
//               onChange={(v) =>
//                 setReaderModel({
//                   ...readerModel,
//                   priceCta: { ...(readerModel?.priceCta || {}), label: v },
//                 })
//               }
//             />
//             <Input
//               label="CTA до Прайс-гурт — route"
//               value={readerModel?.priceCta?.route || ""}
//               onChange={(v) =>
//                 setReaderModel({
//                   ...readerModel,
//                   priceCta: { ...(readerModel?.priceCta || {}), route: v },
//                 })
//               }
//             />
//           </div>
//           <div className={s.grid2}>
//             <Input
//               label="Рукописи — заголовок"
//               value={readerModel?.manuscripts?.title || ""}
//               onChange={(v) =>
//                 setReaderModel({
//                   ...readerModel,
//                   manuscripts: {
//                     ...(readerModel?.manuscripts || {}),
//                     title: v,
//                   },
//                 })
//               }
//             />
//             <Input
//               label="Рукописи — route"
//               value={readerModel?.manuscripts?.route || ""}
//               onChange={(v) =>
//                 setReaderModel({
//                   ...readerModel,
//                   manuscripts: {
//                     ...(readerModel?.manuscripts || {}),
//                     route: v,
//                   },
//                 })
//               }
//             />
//           </div>
//           <HtmlEditor
//             label="Рукописи — текст (HTML)"
//             value={readerModel?.manuscriptsTextHtml || ""}
//             onChange={(v) =>
//               setReaderModel({ ...readerModel, manuscriptsTextHtml: v })
//             }
//           />
//         </Section>
//       </main>

//       {/* Bottom sticky save (mobile-friendly) */}
//       <div className={s.saveBar}>
//         <button
//           className={`${s.btn} ${s.btnPrimary}`}
//           onClick={save}
//           disabled={saving}
//         >
//           {saving ? "Збереження…" : "Зберегти всі документи"}
//         </button>
//       </div>
//     </div>
//   );
// }

// /* =========================
//    UI HELPERS
//    ========================= */
// function Section({ id, title, children }) {
//   return (
//     <section id={id} className={s.card}>
//       <h2 className={s.cardTitle}>{title}</h2>
//       {children}
//     </section>
//   );
// }
// function SubTitle({ children }) {
//   return <h3 className={s.subtitle}>{children}</h3>;
// }
// function Input({ label, value, onChange }) {
//   return (
//     <label className={s.field}>
//       <span className={s.label}>{label}</span>
//       <input
//         className={s.input}
//         value={value || ""}
//         onChange={(e) => onChange(e.target.value)}
//       />
//     </label>
//   );
// }
// function Textarea({ label, value, onChange, rows = 3 }) {
//   return (
//     <label className={s.field}>
//       <span className={s.label}>{label}</span>
//       <textarea
//         className={s.textarea}
//         rows={rows}
//         value={value || ""}
//         onChange={(e) => onChange(e.target.value)}
//       />
//     </label>
//   );
// }

// /* ======== HTML WYSIWYG EDITOR (ReactQuill) ======== */
// function HtmlEditor({ label, value, onChange, placeholder = "" }) {
//   const modules = useMemo(
//     () => ({
//       toolbar: [
//         [{ header: [1, 2, 3, false] }],
//         ["bold", "italic", "underline", "strike", "blockquote"],
//         [
//           { list: "ordered" },
//           { list: "bullet" },
//           { indent: "-1" },
//           { indent: "+1" },
//         ],
//         [{ align: [] }],
//         [{ color: [] }, { background: [] }],
//         ["link"],
//         ["clean"],
//       ],
//       clipboard: { matchVisual: false },
//     }),
//     []
//   );

//   const formats = useMemo(
//     () => [
//       "header",
//       "bold",
//       "italic",
//       "underline",
//       "strike",
//       "blockquote",
//       "list",
//       "bullet",
//       "indent",
//       "align",
//       "color",
//       "background",
//       "link",
//     ],
//     []
//   );

//   const handleChange = useCallback(
//     (html, _delta, source) => {
//       if (source !== "user") return;
//       if ((html || "") === (value || "")) return;
//       onChange(html);
//     },
//     [onChange, value]
//   );

//   return (
//     <label className={s.field}>
//       <span className={s.label}>{label}</span>
//       <div className={s.quillWrap}>
//         <ReactQuill
//           theme="snow"
//           value={value ?? ""}
//           onChange={handleChange}
//           modules={modules}
//           formats={formats}
//           placeholder={placeholder}
//         />
//       </div>
//     </label>
//   );
// }
// src/components/admin/UserCabinetEditor.jsx
import { useEffect, useState, useMemo, useCallback } from "react";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { db } from "../../firebase";
import s from "./UserCabinetEditor.module.css";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

/* =========================
   ГОЛОВНИЙ КОМПОНЕНТ
   ========================= */
export default function UserCabinetEditor() {
  // Firestore refs
  const refUser = doc(db, "siteContent", "userCabinet");
  const refBusiness = doc(db, "siteContent", "blockBusiness");
  const refMaister = doc(db, "siteContent", "blockMaister");
  const refReader = doc(db, "siteContent", "blockReader");
  const refLibrarian = doc(db, "siteContent", "blockLibrarian");

  // Models
  const [userModel, setUserModel] = useState(null);
  const [businessModel, setBusinessModel] = useState(null);
  const [maisterModel, setMaisterModel] = useState(null);
  const [readerModel, setReaderModel] = useState(null);
  const [librarianModel, setLibrarianModel] = useState(null);

  // UI state
  const [activeTab, setActiveTab] = useState("user"); // user | business | maister | reader | librarian
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  // Load all docs
  useEffect(() => {
    (async () => {
      try {
        const [u, b, m, r, l] = await Promise.all([
          getDoc(refUser),
          getDoc(refBusiness),
          getDoc(refMaister),
          getDoc(refReader),
          getDoc(refLibrarian),
        ]);
        setUserModel(u.exists() ? u.data() : {});
        setBusinessModel(b.exists() ? b.data() : {});
        setMaisterModel(m.exists() ? m.data() : {});
        setReaderModel(r.exists() ? r.data() : {});
        setLibrarianModel(l.exists() ? l.data() : {});
      } catch (e) {
        console.error(e);
        setError(
          "Помилка завантаження даних. Перевірте підключення до Firestore."
        );
        setUserModel({});
        setBusinessModel({});
        setMaisterModel({});
        setReaderModel({});
        setLibrarianModel({});
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Save all docs
  const save = async () => {
    setSaving(true);
    setError("");
    try {
      await Promise.all([
        setDoc(refUser, userModel || {}, { merge: true }),
        setDoc(refBusiness, businessModel || {}, { merge: true }),
        setDoc(refMaister, maisterModel || {}, { merge: true }),
        setDoc(refReader, readerModel || {}, { merge: true }),
        setDoc(refLibrarian, librarianModel || {}, { merge: true }),
      ]);
      alert("Збережено!");
    } catch (e) {
      console.error(e);
      setError("Не вдалося зберегти зміни. Спробуйте ще раз.");
    } finally {
      setSaving(false);
    }
  };

  if (
    userModel === null ||
    businessModel === null ||
    maisterModel === null ||
    readerModel === null ||
    librarianModel === null
  ) {
    return (
      <div className={s.loadingWrap}>
        <div className={s.loader} />
        <div className={s.loadingText}>Завантаження редактора…</div>
      </div>
    );
  }

  return (
    <div className={s.editor}>
      {/* Sticky header */}
      <header className={s.header}>
        <div className={s.headerLeft}>
          <div className={s.logoDot} />
          <h1 className={s.title}>Кабінет користувача — адмінка</h1>
        </div>
        <div className={s.headerRight}>
          <button
            className={`${s.tabBtn} ${activeTab === "user" ? s.tabActive : ""}`}
            onClick={() => setActiveTab("user")}
          >
            UserCabinet
          </button>
          <button
            className={`${s.tabBtn} ${
              activeTab === "business" ? s.tabActive : ""
            }`}
            onClick={() => setActiveTab("business")}
          >
            Business
          </button>
          <button
            className={`${s.tabBtn} ${
              activeTab === "maister" ? s.tabActive : ""
            }`}
            onClick={() => setActiveTab("maister")}
          >
            Maister
          </button>
          <button
            className={`${s.tabBtn} ${
              activeTab === "reader" ? s.tabActive : ""
            }`}
            onClick={() => setActiveTab("reader")}
          >
            Reader
          </button>
          <button
            className={`${s.tabBtn} ${
              activeTab === "librarian" ? s.tabActive : ""
            }`}
            onClick={() => setActiveTab("librarian")}
          >
            Librarian
          </button>

          <button
            className={`${s.btn} ${s.btnPrimary}`}
            onClick={save}
            disabled={saving}
          >
            {saving ? "Збереження…" : "Зберегти"}
          </button>
        </div>
      </header>

      {error && <div className={s.error}>{error}</div>}

      {/* Only active section renders */}
      <main className={s.main}>
        {activeTab === "user" && (
          <UserSection model={userModel} setModel={setUserModel} />
        )}
        {activeTab === "business" && (
          <BusinessSection model={businessModel} setModel={setBusinessModel} />
        )}
        {activeTab === "maister" && (
          <MaisterSection model={maisterModel} setModel={setMaisterModel} />
        )}
        {activeTab === "reader" && (
          <ReaderSection model={readerModel} setModel={setReaderModel} />
        )}
        {activeTab === "librarian" && (
          <LibrarianSection
            model={librarianModel}
            setModel={setLibrarianModel}
          />
        )}
      </main>

      {/* Bottom sticky save */}
      <div className={s.saveBar}>
        <button
          className={`${s.btn} ${s.btnPrimary}`}
          onClick={save}
          disabled={saving}
        >
          {saving ? "Збереження…" : "Зберегти всі документи"}
        </button>
      </div>
    </div>
  );
}

/* =========================
   СЕКЦІЇ
   ========================= */

// ---------- USER ----------
function UserSection({ model, setModel }) {
  return (
    <Section id="user" title="UserCabinet">
      <SubTitle>Hero</SubTitle>
      <Textarea
        label="Місія"
        rows={2}
        value={model?.hero?.missionText || ""}
        onChange={(v) =>
          setModel({
            ...model,
            hero: { ...(model?.hero || {}), missionText: v },
          })
        }
      />
      <Textarea
        label="Мета"
        rows={2}
        value={model?.hero?.goalText || ""}
        onChange={(v) =>
          setModel({
            ...model,
            hero: { ...(model?.hero || {}), goalText: v },
          })
        }
      />

      <SubTitle>Соцпосилання</SubTitle>
      <div className={s.grid2}>
        {[
          ["facebookUrl", "Facebook URL"],
          ["email", "Email"],
          ["telegramUrl", "Telegram URL"],
          ["viberUrl", "Viber URL"],
        ].map(([k, label]) => (
          <Input
            key={k}
            label={label}
            value={model?.socialLinks?.[k] || ""}
            onChange={(v) =>
              setModel({
                ...model,
                socialLinks: { ...(model?.socialLinks || {}), [k]: v },
              })
            }
          />
        ))}
      </div>

      <SubTitle>Опис за ролями (HTML)</SubTitle>
      <div className={s.grid2}>
        <HtmlEditor
          label='Член "Клубу Майстрів"'
          value={model?.registration?.byRole?.club || ""}
          onChange={(v) =>
            setModel({
              ...model,
              registration: {
                ...(model?.registration || {}),
                byRole: { ...(model?.registration?.byRole || {}), club: v },
              },
            })
          }
        />
        <HtmlEditor
          label="Бібліотекар"
          value={model?.registration?.byRole?.librarian || ""}
          onChange={(v) =>
            setModel({
              ...model,
              registration: {
                ...(model?.registration || {}),
                byRole: {
                  ...(model?.registration?.byRole || {}),
                  librarian: v,
                },
              },
            })
          }
        />
      </div>
      <div className={s.grid2}>
        {/* <HtmlEditor
          label="Продавець книг в книгарні"
          value={model?.registration?.byRole?.retailer || ""}
          onChange={(v) =>
            setModel({
              ...model,
              registration: {
                ...(model?.registration || {}),
                byRole: { ...(model?.registration?.byRole || {}), retailer: v },
              },
            })
          }
        /> */}
        <HtmlEditor
          label="Майстер"
          value={model?.registration?.byRole?.maister || ""}
          onChange={(v) =>
            setModel({
              ...model,
              registration: {
                ...(model?.registration || {}),
                byRole: { ...(model?.registration?.byRole || {}), maister: v },
              },
            })
          }
        />
        <HtmlEditor
          label="Бізнес-партнер"
          value={model?.registration?.byRole?.business || ""}
          onChange={(v) =>
            setModel({
              ...model,
              registration: {
                ...(model?.registration || {}),
                byRole: { ...(model?.registration?.byRole || {}), business: v },
              },
            })
          }
        />
      </div>

      <SubTitle>Реєстрація / опис</SubTitle>
      <Input
        label="Префікс заголовка"
        value={model?.registration?.prefix || ""}
        onChange={(v) =>
          setModel({
            ...model,
            registration: { ...(model?.registration || {}), prefix: v },
          })
        }
      />
      <HtmlEditor
        label="Опис (HTML)"
        value={model?.registration?.descriptionHtml || ""}
        onChange={(v) =>
          setModel({
            ...model,
            registration: {
              ...(model?.registration || {}),
              descriptionHtml: v,
            },
          })
        }
      />

      <SubTitle>Таби</SubTitle>
      <Repeater
        items={model?.blocks || []}
        renderItem={(b, idx, update, remove) => (
          <div className={s.row}>
            <input
              type="number"
              className={s.inputNarrow}
              value={b.id ?? ""}
              onChange={(e) => update({ ...b, id: Number(e.target.value) })}
            />
            <input
              className={s.input}
              value={b.title ?? ""}
              onChange={(e) => update({ ...b, title: e.target.value })}
            />
            <button
              className={`${s.btn} ${s.btnGhost}`}
              onClick={remove}
              type="button"
            >
              Видалити
            </button>
          </div>
        )}
        onAdd={() =>
          setModel({
            ...model,
            blocks: [
              ...(model?.blocks || []),
              { id: Date.now(), title: "Новий таб" },
            ],
          })
        }
        onChange={(blocks) => setModel({ ...model, blocks })}
        addLabel="Додати таб"
      />

      <SubTitle>Знижка (не підписані)</SubTitle>
      <div className={s.grid2}>
        {[
          ["title", "Заголовок"],
          ["subtitle", "Підзаголовок"],
          ["stepsTitle", "Заголовок для кроків"],
          ["getIdBotUrl", "Посилання на GetID бот"],
          ["channelUrl", "Посилання на Telegram-канал"],
        ].map(([k, label]) => (
          <Input
            key={k}
            label={label}
            value={model?.discount?.unsigned?.[k] || ""}
            onChange={(v) =>
              setModel({
                ...model,
                discount: {
                  ...(model?.discount || {}),
                  unsigned: { ...(model?.discount?.unsigned || {}), [k]: v },
                },
              })
            }
          />
        ))}
      </div>

      <div className={s.cardSoft}>
        <div className={s.labelOnly}>Кроки</div>
        <Repeater
          items={model?.discount?.unsigned?.steps || []}
          renderItem={(val, idx, update, remove) => (
            <div className={s.rowNew}>
              <textarea
                className={s.textareaNew}
                rows={2}
                value={val}
                onChange={(e) => update(e.target.value)}
              />
              <button
                className={`${s.btnNew} ${s.btnGhost}`}
                onClick={remove}
                type="button"
              >
                −
              </button>
            </div>
          )}
          onAdd={() =>
            setModel({
              ...model,
              discount: {
                ...(model?.discount || {}),
                unsigned: {
                  ...(model?.discount?.unsigned || {}),
                  steps: [
                    ...(model?.discount?.unsigned?.steps || []),
                    "Новий крок",
                  ],
                },
              },
            })
          }
          onChange={(steps) =>
            setModel({
              ...model,
              discount: {
                ...(model?.discount || {}),
                unsigned: { ...(model?.discount?.unsigned || {}), steps },
              },
            })
          }
          addLabel="Додати крок"
        />
      </div>

      <SubTitle>Знижка (підписані)</SubTitle>
      <div className={s.grid3}>
        {[
          ["noteTitle", "Заголовок"],
          ["note", "Примітка"],
          ["inviteCta", "Кнопка запрошення"],
        ].map(([k, label]) => (
          <Input
            key={k}
            label={label}
            value={model?.discount?.signed?.[k] || ""}
            onChange={(v) =>
              setModel({
                ...model,
                discount: {
                  ...(model?.discount || {}),
                  signed: { ...(model?.discount?.signed || {}), [k]: v },
                },
              })
            }
          />
        ))}
      </div>

      <SubTitle>Слони</SubTitle>
      <HtmlEditor
        label='Текст перед курсом (HTML) — наприклад: "Ви можете <br /> сплачувати слонами..."'
        value={model?.elephants?.leadHtml || ""}
        onChange={(v) =>
          setModel({
            ...model,
            elephants: { ...(model?.elephants || {}), leadHtml: v },
          })
        }
      />
      <div className={s.grid2}>
        <Input
          label="Інфо для клубу"
          value={model?.elephants?.infoClub || ""}
          onChange={(v) =>
            setModel({
              ...model,
              elephants: { ...(model?.elephants || {}), infoClub: v },
            })
          }
        />
        <Input
          label="Інфо для читача"
          value={model?.elephants?.infoReader || ""}
          onChange={(v) =>
            setModel({
              ...model,
              elephants: { ...(model?.elephants || {}), infoReader: v },
            })
          }
        />
      </div>
    </Section>
  );
}

// ---------- BUSINESS ----------
function BusinessSection({ model, setModel }) {
  return (
    <Section id="business" title="BlockBusiness (Бізнес-партнер)">
      <div className={s.grid2}>
        <Input
          label="Анкета партнера — назва"
          value={model?.partnerForm?.label || ""}
          onChange={(v) =>
            setModel({
              ...model,
              partnerForm: { ...(model?.partnerForm || {}), label: v },
            })
          }
        />
        <Input
          label="Анкета партнера — URL"
          value={model?.partnerForm?.url || ""}
          onChange={(v) =>
            setModel({
              ...model,
              partnerForm: { ...(model?.partnerForm || {}), url: v },
            })
          }
        />
      </div>

      <HtmlEditor
        label="Intro (HTML) Бізнес"
        value={model?.partnerIntroHtml || ""}
        onChange={(v) => setModel({ ...model, partnerIntroHtml: v })}
      />

      <Input
        label="H1 — Контакти персонального менеджера"
        value={model?.personalManagerContact || ""}
        onChange={(v) => setModel({ ...model, personalManagerContact: v })}
      />
      <Textarea
        label="Опис менеджера (текст)"
        value={model?.personalManager || ""}
        onChange={(v) => setModel({ ...model, personalManager: v })}
      />

      <div className={s.grid2}>
        <Input
          label="Route «Прайс-гурт»"
          value={model?.priceRoute || ""}
          onChange={(v) => setModel({ ...model, priceRoute: v })}
        />
        <Input
          label="Текст лінку «Прайс-гурт»"
          value={model?.priceLinkText || ""}
          onChange={(v) => setModel({ ...model, priceLinkText: v })}
        />
      </div>

      <HtmlEditor
        label="Абзац про «Прайс-гурт» (HTML)"
        value={model?.optIntroHtml || ""}
        onChange={(v) => setModel({ ...model, optIntroHtml: v })}
      />

      <div className={s.grid2}>
        <Input
          label="Плейлист — назва"
          value={model?.salesPlaylist?.label || ""}
          onChange={(v) =>
            setModel({
              ...model,
              salesPlaylist: { ...(model?.salesPlaylist || {}), label: v },
            })
          }
        />
        <Input
          label="Плейлист — URL"
          value={model?.salesPlaylist?.url || ""}
          onChange={(v) =>
            setModel({
              ...model,
              salesPlaylist: { ...(model?.salesPlaylist || {}), url: v },
            })
          }
        />
      </div>

      <HtmlEditor
        label="Примітка до плейлиста (HTML)"
        value={model?.salesPlaylistNoteHtml || ""}
        onChange={(v) => setModel({ ...model, salesPlaylistNoteHtml: v })}
      />

      <div className={s.grid3}>
        <Input
          label="H1 — Знижки"
          value={model?.discountTitle || ""}
          onChange={(v) => setModel({ ...model, discountTitle: v })}
        />
        <Input
          label="H1 — Комерційни новини"
          value={model?.newsTitle || ""}
          onChange={(v) => setModel({ ...model, newsTitle: v })}
        />
        <Input
          label="H1 — Звернення видавництва"
          value={model?.turnToTitle || ""}
          onChange={(v) => setModel({ ...model, turnToTitle: v })}
        />
      </div>

      <div className={s.grid3}>
        <HtmlEditor
          label="Текст «Знижки» (HTML)"
          value={model?.discountHtml || ""}
          onChange={(v) => setModel({ ...model, discountHtml: v })}
        />
        <HtmlEditor
          label="Новини (HTML)"
          value={model?.newsHtml || ""}
          onChange={(v) => setModel({ ...model, newsHtml: v })}
        />
        <HtmlEditor
          label="Звернення (HTML)"
          value={model?.turnToHtml || ""}
          onChange={(v) => setModel({ ...model, turnToHtml: v })}
        />
      </div>

      <div className={s.grid2}>
        <HtmlEditor
          label="Питання (HTML)"
          value={model?.questionHtml || ""}
          onChange={(v) => setModel({ ...model, questionHtml: v })}
        />
        <HtmlEditor
          label="Опис PDF (HTML)"
          value={model?.pdfToHtml || ""}
          onChange={(v) => setModel({ ...model, pdfToHtml: v })}
        />
      </div>
    </Section>
  );
}

// ---------- MAISTER ----------
function MaisterSection({ model, setModel }) {
  return (
    <Section id="maister" title="BlockMaister (Майстер/Автор)">
      <div className={s.grid2}>
        <Input
          label="Заголовок"
          value={model?.authorForm?.label || ""}
          onChange={(v) =>
            setModel({
              ...model,
              authorForm: { ...(model?.authorForm || {}), label: v },
            })
          }
        />
        <Input
          label="URL"
          value={model?.authorForm?.url || ""}
          onChange={(v) =>
            setModel({
              ...model,
              authorForm: { ...(model?.authorForm || {}), url: v },
            })
          }
        />
      </div>

      <HtmlEditor
        label="Оновіть дані (HTML)"
        value={model?.updateDataHtml || ""}
        onChange={(v) => setModel({ ...model, updateDataHtml: v })}
      />

      <div className={s.grid2}>
        <Input
          label="Заголовок"
          value={model?.masterForm?.label || ""}
          onChange={(v) =>
            setModel({
              ...model,
              masterForm: { ...(model?.masterForm || {}), label: v },
            })
          }
        />
        <Input
          label="URL"
          value={model?.masterForm?.url || ""}
          onChange={(v) =>
            setModel({
              ...model,
              masterForm: { ...(model?.masterForm || {}), url: v },
            })
          }
        />
      </div>

      <HtmlEditor
        label="Пояснення (HTML)"
        value={model?.anketMaisterHtml || ""}
        onChange={(v) => setModel({ ...model, anketMaisterHtml: v })}
      />

      <Input
        label="Заголовок"
        value={model?.editorEmail || ""}
        onChange={(v) => setModel({ ...model, editorEmail: v })}
      />

      <HtmlEditor
        label=" (HTML)"
        value={model?.personalManagerHtml || ""}
        onChange={(v) => setModel({ ...model, personalManagerHtml: v })}
      />

      <div className={s.grid2}>
        <Input
          label="Заголовок"
          value={model?.submitManuscript?.label || ""}
          onChange={(v) =>
            setModel({
              ...model,
              submitManuscript: {
                ...(model?.submitManuscript || {}),
                label: v,
              },
            })
          }
        />
        <Input
          label="URL"
          value={model?.submitManuscript?.mailto || ""}
          onChange={(v) =>
            setModel({
              ...model,
              submitManuscript: {
                ...(model?.submitManuscript || {}),
                mailto: v,
              },
            })
          }
        />
      </div>

      <div className={s.grid2}>
        <Input
          label="Заголовок"
          value={model?.manuscriptForm?.label || ""}
          onChange={(v) =>
            setModel({
              ...model,
              manuscriptForm: { ...(model?.manuscriptForm || {}), label: v },
            })
          }
        />
        <Input
          label="URL"
          value={model?.manuscriptForm?.url || ""}
          onChange={(v) =>
            setModel({
              ...model,
              manuscriptForm: { ...(model?.manuscriptForm || {}), url: v },
            })
          }
        />
      </div>

      <HtmlEditor
        label="Розділ про рукопис (HTML)"
        value={model?.manuscriptHtml || ""}
        onChange={(v) => setModel({ ...model, manuscriptHtml: v })}
      />

      <Input
        label="Заголовок"
        value={model?.helpAutorTitle || ""}
        onChange={(v) => setModel({ ...model, helpAutorTitle: v })}
      />
      <HtmlEditor
        label="Текст (HTML)"
        value={model?.helpAutorHtml || ""}
        onChange={(v) => setModel({ ...model, helpAutorHtml: v })}
      />

      <div className={s.grid2}>
        <Input
          label="Заголовок"
          value={model?.opikunForm?.label || ""}
          onChange={(v) =>
            setModel({
              ...model,
              opikunForm: { ...(model?.opikunForm || {}), label: v },
            })
          }
        />
        <Input
          label=" URL"
          value={model?.opikunForm?.url || ""}
          onChange={(v) =>
            setModel({
              ...model,
              opikunForm: { ...(model?.opikunForm || {}), url: v },
            })
          }
        />
      </div>

      <HtmlEditor
        label="Опікунська рада — опис (HTML)"
        value={model?.opicunTextHtml || ""}
        onChange={(v) => setModel({ ...model, opicunTextHtml: v })}
      />

      <div className={s.grid2}>
        <Input
          label="Заголовок"
          value={model?.searchAutor?.label || ""}
          onChange={(v) =>
            setModel({
              ...model,
              searchAutor: { ...(model?.searchAutor || {}), label: v },
            })
          }
        />
        <Input
          label=" URL"
          value={model?.searchAutor?.url || ""}
          onChange={(v) =>
            setModel({
              ...model,
              searchAutor: { ...(model?.searchAutor || {}), url: v },
            })
          }
        />
      </div>

      <HtmlEditor
        label="Текст (HTML)"
        value={model?.searchAutorTextHtml || ""}
        onChange={(v) => setModel({ ...model, searchAutorTextHtml: v })}
      />

      <div className={s.grid2}>
        <Input
          label="Заголовок"
          value={model?.tgChannel?.label || ""}
          onChange={(v) =>
            setModel({
              ...model,
              tgChannel: { ...(model?.tgChannel || {}), label: v },
            })
          }
        />
        <Input
          label="Заголовок"
          value={model?.tgChannel?.url || ""}
          onChange={(v) =>
            setModel({
              ...model,
              tgChannel: { ...(model?.tgChannel || {}), url: v },
            })
          }
        />
      </div>

      <HtmlEditor
        label="Заголовок"
        value={model?.tgChanelTextHtml || ""}
        onChange={(v) => setModel({ ...model, tgChanelTextHtml: v })}
      />
      <div className={s.grid2}>
        <Input
          label="Додатковий заголовок — назва"
          value={model?.extraHeading?.label || ""}
          onChange={(v) =>
            setModel({
              ...model,
              extraHeading: { ...(model?.extraHeading || {}), label: v },
            })
          }
        />
        <Input
          label="Додатковий заголовок — URL"
          value={model?.extraHeading?.url || ""}
          onChange={(v) =>
            setModel({
              ...model,
              extraHeading: { ...(model?.extraHeading || {}), url: v },
            })
          }
        />
      </div>

      {/* --- ДОДАТКОВИЙ HTML-БЛОК --- */}
      <HtmlEditor
        label="Додатковий розділ (HTML)"
        value={model?.extraSectionHtml || ""}
        onChange={(v) => setModel({ ...model, extraSectionHtml: v })}
      />
    </Section>
  );
}

// ---------- READER ----------
function ReaderSection({ model, setModel }) {
  return (
    <Section id="reader" title="BlockReader (Читач / Клуб майстрів)">
      <Input
        label="Заголовок (Telegram)"
        value={model?.telegramTitle || ""}
        onChange={(v) => setModel({ ...model, telegramTitle: v })}
      />
      <HtmlEditor
        label="Опис (HTML)"
        value={model?.descriptionHtml || ""}
        onChange={(v) => setModel({ ...model, descriptionHtml: v })}
      />

      <div className={s.grid2}>
        <Input
          label="Опікунська рада — назва"
          value={model?.guardianForm?.label || ""}
          onChange={(v) =>
            setModel({
              ...model,
              guardianForm: { ...(model?.guardianForm || {}), label: v },
            })
          }
        />
        <Input
          label="Опікунська рада — URL"
          value={model?.guardianForm?.url || ""}
          onChange={(v) =>
            setModel({
              ...model,
              guardianForm: { ...(model?.guardianForm || {}), url: v },
            })
          }
        />
      </div>
      <HtmlEditor
        label="Опікунська рада — текст (HTML)"
        value={model?.guardianTextHtml || ""}
        onChange={(v) => setModel({ ...model, guardianTextHtml: v })}
      />

      <div className={s.grid2}>
        <Input
          label="Гурт-замовлення — назва"
          value={model?.groupOrder?.label || ""}
          onChange={(v) =>
            setModel({
              ...model,
              groupOrder: { ...(model?.groupOrder || {}), label: v },
            })
          }
        />
        <Input
          label="Гурт-замовлення — URL"
          value={model?.groupOrder?.url || ""}
          onChange={(v) =>
            setModel({
              ...model,
              groupOrder: { ...(model?.groupOrder || {}), url: v },
            })
          }
        />
      </div>
      <HtmlEditor
        label="Гурт-замовлення — текст (HTML)"
        value={model?.groupOrderTextHtml || ""}
        onChange={(v) => setModel({ ...model, groupOrderTextHtml: v })}
      />

      <div className={s.grid2}>
        <Input
          label="CTA до Прайс-гурт — текст"
          value={model?.priceCta?.label || ""}
          onChange={(v) =>
            setModel({
              ...model,
              priceCta: { ...(model?.priceCta || {}), label: v },
            })
          }
        />
        <Input
          label="CTA до Прайс-гурт — route"
          value={model?.priceCta?.route || ""}
          onChange={(v) =>
            setModel({
              ...model,
              priceCta: { ...(model?.priceCta || {}), route: v },
            })
          }
        />
      </div>

      <div className={s.grid2}>
        <Input
          label="Рукописи — заголовок"
          value={model?.manuscripts?.title || ""}
          onChange={(v) =>
            setModel({
              ...model,
              manuscripts: { ...(model?.manuscripts || {}), title: v },
            })
          }
        />
        <Input
          label="Рукописи — route"
          value={model?.manuscripts?.route || ""}
          onChange={(v) =>
            setModel({
              ...model,
              manuscripts: { ...(model?.manuscripts || {}), route: v },
            })
          }
        />
      </div>
      <HtmlEditor
        label="Рукописи — текст (HTML)"
        value={model?.manuscriptsTextHtml || ""}
        onChange={(v) => setModel({ ...model, manuscriptsTextHtml: v })}
      />
    </Section>
  );
}

// ---------- LIBRARIAN (NEW) ----------
function LibrarianSection({ model, setModel }) {
  return (
    <Section id="librarian" title="BlockLibrarian (Бібліотекар)">
      <Input
        label='H1 — Заголовок (напр. "Настав час бібліотек")'
        value={model?.introTitle || ""}
        onChange={(v) => setModel({ ...model, introTitle: v })}
      />
      <HtmlEditor
        label="Текст під заголовком (HTML)"
        value={model?.introHtml || ""}
        onChange={(v) => setModel({ ...model, introHtml: v })}
      />

      <div className={s.grid2}>
        <Input
          label="Опікунська рада — назва"
          value={model?.guardianForm?.label || ""}
          onChange={(v) =>
            setModel({
              ...model,
              guardianForm: { ...(model?.guardianForm || {}), label: v },
            })
          }
        />
        <Input
          label="Опікунська рада — URL"
          value={model?.guardianForm?.url || ""}
          onChange={(v) =>
            setModel({
              ...model,
              guardianForm: { ...(model?.guardianForm || {}), url: v },
            })
          }
        />
      </div>
      <HtmlEditor
        label="Опікунська рада — текст (HTML)"
        value={model?.guardianTextHtml || ""}
        onChange={(v) => setModel({ ...model, guardianTextHtml: v })}
      />

      <div className={s.grid2}>
        <Input
          label="Рукописи — заголовок"
          value={model?.manuscripts?.title || ""}
          onChange={(v) =>
            setModel({
              ...model,
              manuscripts: { ...(model?.manuscripts || {}), title: v },
            })
          }
        />
        <Input
          label="Рукописи — route"
          value={model?.manuscripts?.route || ""}
          onChange={(v) =>
            setModel({
              ...model,
              manuscripts: { ...(model?.manuscripts || {}), route: v },
            })
          }
        />
      </div>
      <HtmlEditor
        label="Рукописи — текст (HTML)"
        value={model?.manuscriptsTextHtml || ""}
        onChange={(v) => setModel({ ...model, manuscriptsTextHtml: v })}
      />

      <SubTitle>Каталог для бібліотек (банер)</SubTitle>
      <div className={s.grid3}>
        <Input
          label="Текст кнопки"
          value={model?.catalogBanner?.buttonLabel || ""}
          onChange={(v) =>
            setModel({
              ...model,
              catalogBanner: {
                ...(model?.catalogBanner || {}),
                buttonLabel: v,
              },
            })
          }
        />
        <Input
          label="URL (посилання на каталог)"
          value={model?.catalogBanner?.url || ""}
          onChange={(v) =>
            setModel({
              ...model,
              catalogBanner: { ...(model?.catalogBanner || {}), url: v },
            })
          }
        />
      </div>
      <HtmlEditor
        label="Текст банера (HTML)"
        value={model?.catalogBanner?.noteHtml || ""}
        onChange={(v) =>
          setModel({
            ...model,
            catalogBanner: { ...(model?.catalogBanner || {}), noteHtml: v },
          })
        }
      />
    </Section>
  );
}

/* =========================
   UI HELPERS
   ========================= */
function Section({ id, title, children }) {
  return (
    <section id={id} className={s.card}>
      <h2 className={s.cardTitle}>{title}</h2>
      {children}
    </section>
  );
}

function SubTitle({ children }) {
  return <h3 className={s.subtitle}>{children}</h3>;
}

function Input({ label, value, onChange }) {
  return (
    <label className={s.field}>
      <span className={s.label}>{label}</span>
      <input
        className={s.input}
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
      />
    </label>
  );
}

function Textarea({ label, value, onChange, rows = 3 }) {
  return (
    <label className={s.field}>
      <span className={s.label}>{label}</span>
      <textarea
        className={s.textarea}
        rows={rows}
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
      />
    </label>
  );
}

/* ======== HTML WYSIWYG EDITOR (ReactQuill) ======== */
function HtmlEditor({ label, value, onChange, placeholder = "" }) {
  const modules = useMemo(
    () => ({
      toolbar: [
        [{ header: [1, 2, 3, false] }],
        ["bold", "italic", "underline", "strike", "blockquote"],
        [
          { list: "ordered" },
          { list: "bullet" },
          { indent: "-1" },
          { indent: "+1" },
        ],
        [{ align: [] }],
        [{ color: [] }, { background: [] }],
        ["link"],
        ["clean"],
      ],
      clipboard: { matchVisual: false },
    }),
    []
  );

  const formats = useMemo(
    () => [
      "header",
      "bold",
      "italic",
      "underline",
      "strike",
      "blockquote",
      "list",
      "bullet",
      "indent",
      "align",
      "color",
      "background",
      "link",
    ],
    []
  );

  const handleChange = useCallback(
    (html, _delta, source) => {
      if (source !== "user") return;
      if ((html || "") === (value || "")) return;
      onChange(html);
    },
    [onChange, value]
  );

  return (
    <label className={s.field}>
      <span className={s.label}>{label}</span>
      <div className={s.quillWrap}>
        <ReactQuill
          theme="snow"
          value={value ?? ""}
          onChange={handleChange}
          modules={modules}
          formats={formats}
          placeholder={placeholder}
        />
      </div>
    </label>
  );
}

/* ======== Repeater helper ======== */
function Repeater({ items, renderItem, onAdd, onChange, addLabel = "Додати" }) {
  return (
    <div className={s.cardSoft}>
      {(items || []).map((it, idx) => {
        const update = (newItem) => {
          const next = [...items];
          next[idx] = newItem;
          onChange(next);
        };
        const remove = () => {
          const next = items.filter((_, i) => i !== idx);
          onChange(next);
        };
        return <div key={idx}>{renderItem(it, idx, update, remove)}</div>;
      })}
      <button className={`${s.btn} ${s.btnSoft}`} onClick={onAdd} type="button">
        {addLabel}
      </button>
    </div>
  );
}
